.header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  padding-bottom: 1.6rem;
  border-bottom: 1px solid var(--color-grayscale-trout);
}

.header {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.items-container {
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

  &:not(:last-child) {
    border-bottom: 1px solid var(--color-grayscale-trout);
  }
}
